import { types } from './actions';

const initialState = {
  areDefaultInternalQuoteNotesSaving: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_ERROR:
      return {
        ...state,
        areDefaultInternalQuoteNotesSaving: false,
      };
    case types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_REQUEST:
      return {
        ...state,
        areDefaultInternalQuoteNotesSaving: true,
      };
    case types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_SUCCESS:
      return {
        ...state,
        areDefaultInternalQuoteNotesSaving: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.digitalQuote.internalNotes;

export const areDefaultInternalQuoteNotesSaving = (state) =>
  getScope(state).areDefaultInternalQuoteNotesSaving;
